angular.module("whitelabelApp")
    .controller("ResultsController", ['$scope', '$routeParams', '$resource', '$http', 'localStorageService', '$location', function($scope, $routeParams, $resource, $http, localStorageService, $location){
        $scope.loadingStatus = true;
        $scope.name = 'ResultsController';
        $scope.params = $routeParams;
        $scope.calculations = [];
        var elem = document.getElementById("colorFinder");
        $scope.primaryColor = window.getComputedStyle(elem, null).getPropertyValue("background-color");
        $scope.highlightColor = window.getComputedStyle(elem, null).getPropertyValue("color");
        var sessionId = localStorageService.get('sessionId');
        if(sessionId == null || sessionId.length === 0 || sessionId == 0) {
            $location.path('/');
            return;
        }
        $http.get('/api/session/' + sessionId + '/calculations?timestamp=' + new Date().getTime()).then(function successCallback(response) {
            var introQuesionSets = [1, 2, 3];
            for (i = 0; i < introQuesionSets.length; i++) {
                var questionSetId = introQuesionSets[i];
                var comparitor = function (questionSetValue) { return questionSetValue.id == questionSetId };
                if(!response.data.questionSetValues.filter(comparitor).length || !response.data.questionSetValues.filter(comparitor)[0].questionSetComplete)
                {
                    $location.path('/Step/'+questionSetId);
                    return;
                }
            }
            // var filteredResponse = [];
            $scope.linearQuestionsStarted = false;
            response.data.questionSetValues.forEach(function(qs, i){
                var initialQuestions = [0, 1, 2, 3];
                if(initialQuestions.indexOf(qs.id) < 0 && qs.questionSetComplete) {
                    $scope.linearQuestionsStarted = true;
                }
            });
            $scope.questionSets = response.data.questionSetValues;
            $scope.maturity = response.data.maturity;
            $scope.content = response.data.content;
            $scope.hasEmail = response.data.hasEmail;
            // redirect to initial questions if not complete
            // [1, 2, 3].forEach(fucntion(i) {
            //     alert(i);
            // });
            $scope.loadingStatus = false;
            

            }, function errorCallback(response) {});
        $scope.maturityQuestionSets = ['Digital Capability', 'Leadership Capability', 'Digital Skills'];
        $scope.filterByMaturityQuestionSets = function(questionSet) {
            return ($scope.maturityQuestionSets.indexOf(questionSet.title) !== -1);
        };
    }]);
